import { useState } from 'react';
import styles from './ToggleDeletePatientCaseModal.module.scss';
import { Button, ErrorModalContent, Modal, Text } from 'components';
import { selectModalsErrors } from 'store/app/selectors';
import { appActions } from 'store/app/slice';
import { selectCurrentPatientCase } from 'store/patients/selectors';
import { patientsActions } from 'store/patients/slice';
import { useDispatch, useSelector } from 'store/utils';

const deleteText = {
  title: 'Delete patient',
  contentTitle: 'Are you sure you want to delete this patient? Please confirm.',
  contentText: 'Once this patient is deleted, it cannot be restored',
  actionText: 'Delete',
  errorTitle: 'Delete patient action failed',
  errorSubtitle: 'The patient case deletion failed due to technical problems',
};

export const ToggleDeletePatientCaseModal = () => {
  const dispatch = useDispatch();

  const currentPatientCase = useSelector(selectCurrentPatientCase);
  const [displayError, setDisplayError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const errorMessage = useSelector(selectModalsErrors).deletePatientError;
  const errorMessageText = `The patient case deletion failed. ${errorMessage}`;

  const handleClose = () => {
    dispatch(
      appActions.setIsModalOpened({
        name: 'deletePatient',
        isOpened: false,
      }),
    );
  };

  const onToggleHandler = async () => {
    if (!currentPatientCase) {
      handleClose();
      return;
    }
    if (isLoading) return;
    try {
      setIsLoading(true);
      await dispatch(patientsActions.deletePatientCase(currentPatientCase.id)).unwrap();
      handleClose();
      dispatch(appActions.setModalErrorText({ name: 'deletePatientError', errorText: '' }));
    } catch (error: any) {
      dispatch(appActions.setModalErrorText({ name: 'deletePatientError', errorText: error?.title }));
      setDisplayError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal title={deleteText.title} onClose={handleClose}>
      {displayError ? (
        <ErrorModalContent
          title={deleteText.errorTitle}
          subtitle={errorMessage ? errorMessageText : deleteText.errorSubtitle}
          onConfirm={handleClose}
        />
      ) : (
        <div className={styles.container}>
          <div className={styles.content}>
            <Text type="body-big" className={styles.contentTitle}>
              {deleteText.contentTitle}
            </Text>
            <Text type="body2" className={styles.contentText}>
              {deleteText.contentText}
            </Text>
          </div>
          <div className={styles.buttonRow}>
            <Button isLink onClick={handleClose}>
              Cancel
            </Button>
            <Button onClick={onToggleHandler}>{deleteText.actionText}</Button>
          </div>
        </div>
      )}
    </Modal>
  );
};
